"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensTilePlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LensTilePlaceholder_module_css_1 = __importDefault(require("./LensTilePlaceholder.module.css"));
const animations_module_css_1 = __importDefault(require("./animations.module.css"));
const LensTile_1 = require("../LensTile");
const clsx_1 = __importDefault(require("clsx"));
/**
 * Animated LensTile Placeholder
 */
function LensTilePlaceholder({ size }) {
    const dimensions = LensTile_1.LensTileDimensionsBySize[size];
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(LensTilePlaceholder_module_css_1.default.placeHolderTile, animations_module_css_1.default.loadingSkeleton), style: dimensions }));
}
exports.LensTilePlaceholder = LensTilePlaceholder;
//# sourceMappingURL=LensTilePlaceholder.js.map